import feathersClient from "../../feathers-client";
import _ from 'lodash'


const defaultRateListPagination = {
	total:100,
	$skip:0,
	$limit:10,
}
const defaultRateListPaginationFilter = {

};

export default {
	namespaced:true,
	state:{
		rateById:'',
		rateList:[],
		rateListPagination:defaultRateListPagination,
		rateListPaginationFilter:defaultRateListPaginationFilter,
		trustJobRates:[],
		careLocationJobRates:[],
		hourlyJobRates:[],
		trustHourlyJobRates:[],
	},
	getters:{
		setCurrentListPage:(state)=> {
			const {$limit,$skip} = state.rateListPagination;
			return $skip / $limit + 1;
		},
	},
	mutations:{
		SET_RATE_BY_ID:(state,data)=>{state.rateById =data},
		SET_RATE_LIST:(state,data)=> {state.rateList = data},
		SET_RATE_LIST_PAGINATION:(state,data) => {state.rateListPagination = {...state.rateListPagination,...data}},
		SET_RATE_LIST_PAGINATION_FILTER:(state,data) => {state.rateListPaginationFilter = {...state.rateListPaginationFilter,...data}},
		SET_TRUST_JOB_RATES:(state,data)=>{state.trustJobRates =data},
		SET_CARE_LOCATION_JOB_RATES:(state,data)=>{state.careLocationJobRates =data},
		SET_HOURLY_JOB_RATES:(state,data)=>{state.hourlyJobRates =data},
		SET_TRUST_HOURLY_JOB_RATES:(state,data)=>{state.hourlyJobRates =data},

	},
	actions:{
		setNewRateListPage:({commit,state},page) =>{
			const $skip = (page - 1) * state.rateListPagination.$limit;
			commit('SET_RATE_LIST_PAGINATION', { $skip });
			commit('SET_RATE_LIST_PAGINATION_FILTER', { $skip });
		},
		getAllRatesForList: async({commit,rootGetters},filter) => {
			const results = await feathersClient.service('/api/v3/rate-cards').find({
				query:{
					$role:rootGetters.currentUserRole,
					...filter,
				}
			});
			commit('SET_RATE_LIST',results.data),
			commit('SET_RATE_LIST_PAGINATION', {total:results.total})
		},
		createRateCardForTrust:async({rootGetters},data) => {
			const results = await feathersClient.service('/api/v3/rate-cards').create(data,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			return results
		},
		getRateConfigById :async({rootGetters,commit},id) => {
			const results = await feathersClient.service('/api/v3/rate-cards').get(id,{
				query:{
					$role:rootGetters.currentUserRole,
				}
			});
			commit('SET_RATE_BY_ID',results)
		},
		getJobRatesForTrust: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/job-rates').find({
				query:{
					$role:rootGetters.currentUserRole,
					...filter
				}
			});
		commit('SET_TRUST_JOB_RATES',results)
		},
		getJobRatesForCareLocations: async({rootGetters,commit},filter) => {
			delete filter.$skip
			delete filter.$limit
			const results = await feathersClient.service('/api/v3/job-rates').find({
				query:{
					$role:rootGetters.currentUserRole,
					...filter
				}
			});
		commit('SET_CARE_LOCATION_JOB_RATES',results)
		},
		createJobRate: async({rootGetters,commit},data) => {
			const results = await feathersClient.service('/api/v3/job-rates').create(data,{
				query:{
					$role:rootGetters.currentUserRole
				}
			});
			return results;
		},
		upddateJobRates: async ({rootGetters,commit},data) => {
			const id= data.id
			delete data.id
			const results = await feathersClient.service('/api/v3/job-rates').patch(id,data,{
				query:{
					$role:rootGetters.currentUserRole
				}
			})
			return results
		},
		updateRateCardById: async ({rootGetters,commit},data)=>{
			const id = data.id
			delete data.id
			const results = await feathersClient.service('/api/v3/rate-cards').patch(id,data,{
				query:{
					$role:rootGetters.currentUserRole
				}
			});
			commit('SET_RATE_BY_ID',results)
			return results;
		},
		findTheHourlyValueOfRateCard: async({rootGetters,commit},filter) =>{
			const results = await feathersClient.service('/api/v3/job-rates').find({
				query:{
					$role:rootGetters.currentUserRole,
					...filter,
				}
			});
			return results;
		},
		getChangedJobRatesOfCareLocations: async({rootGetters,commit},filter) => {
			const results = await feathersClient.service('/api/v3/job-rates').find({
				query:{
					$role:rootGetters.currentUserRole,
					fields:['changed'],
					$changed:true,
					$paginate:false,
					...filter

				}
			});
		return results
		},
		getHourlyJobRates: async ({rootGetters,commit},filter) =>{
			delete filter.$skip
			delete filter.$limit
			const results = await feathersClient.service('/api/v3/job-rates').find({
				query:{
					$role:rootGetters.currentUserRole,
					$changed:true,
					$paginate:false,
					...filter
				}
			});
			commit('SET_HOURLY_JOB_RATES',results);
		},
		getTrustHourlyJobRates: async ({rootGetters,commit},filter) =>{
			delete filter.$skip
			delete filter.$limit
			const results = await feathersClient.service('/api/v3/job-rates').find({
				query:{
					$role:rootGetters.currentUserRole,
					$paginate:false,
					...filter
				}
			});
			commit('SET_TRUST_HOURLY_JOB_RATES',results);
		},
		getExportJobRatesDetails: async ({rootGetters,commit},filter) =>{
			const results = await feathersClient.service('/api/v3/export-job-rates').find({
				query:{
					$role:rootGetters.currentUserRole,
					...filter
				}
			});
			return results
		},
		getUpcomingJobRatesOfCareLocations: async({rootGetters,commit},filter) => {
			var newFilter = _.cloneDeep(filter)
			delete newFilter?.$hourJobRateForToday
			delete newFilter?.$group
			const results = await feathersClient.service('/api/v3/upcoming-rate-changes').find({
				query:{
					$role:rootGetters.currentUserRole,
					...newFilter
				}
			});
		return results
		},

		getCustomizeJobRatesOfCareLocation:async ({rootGetters,commit},filter) => {
			var newFilter = _.cloneDeep(filter)
			delete newFilter?.$hourJobRateForToday
			delete newFilter?.$group
			delete newFilter?.applicability
			delete newFilter?.$paginate
			const results = await feathersClient.service('/api/v3/carelocation-rate-customizations').find({
				query:{
					$role:rootGetters.currentUserRole,
					...newFilter
				}
			});
			return results
		},
		getTrustPayRateRangeConfig: async ({rootGetters, commit}, filter) =>{
			const results = await feathersClient.service('/api/v3/trustpayraterangeconfigurations').find({
				query:{
					$role:rootGetters.currentUserRole,
					$paginate:false,
					...filter
				}
			});
			return results?.length > 0 ? results[0] : {};
		},
		updatePayRangeConfig:async ({rootGetters, commit}, data) => {
			const id= data.id
			delete data.id
			const results = await feathersClient.service('/api/v3/trustpayraterangeconfigurations').patch(id,data,{
				query:{
					$role:rootGetters.currentUserRole
				}
			});
			return results;
		}
	}
}
